import { type FC } from 'react';

export type CanvasView = 'canvas' | 'tree' | 'table';

interface ViewSwitcherProps {
  activeView: CanvasView;
  onViewChange: (view: CanvasView) => void;
}

const views: { key: CanvasView; label: string; icon: string }[] = [
  { key: 'canvas', label: 'Canvas', icon: '\u25A6' },
  { key: 'tree', label: 'Arbre', icon: '\u2442' },
  { key: 'table', label: 'Tableau', icon: '\u2630' },
];

export const ViewSwitcher: FC<ViewSwitcherProps> = ({ activeView, onViewChange }) => {
  return (
    <>
      {views.map((v) => {
        const isActive = activeView === v.key;
        return (
          <button
            key={v.key}
            onClick={() => onViewChange(v.key)}
            title={v.label}
            style={{
              padding: '6px 10px',
              backgroundColor: isActive ? 'var(--color-background)' : 'transparent',
              border: 'none',
              color: isActive ? 'var(--color-primary)' : 'var(--color-text)',
              cursor: 'pointer',
              fontSize: 14,
              borderRadius: 'var(--radius-md)',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              transition: 'var(--transition-fast)',
            }}
          >
            <span style={{ fontSize: 16 }}>{v.icon}</span>
            <span style={{ fontSize: 'var(--font-size-xs)' }}>{v.label}</span>
          </button>
        );
      })}
    </>
  );
};

export default ViewSwitcher;
